export const CONNECT_PORT_NAME = 'transport';
export const TRANSPORT_NAME = 'ChromeTransport';
